module.exports = __webpack_public_path__ + "static/media/icon-play-youtube.bed3878b.svg";